import React from 'react'

export default function FaceFeature({ scaleX, fill, verticalOffset }) {
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <path
        opacity="0.4"
        d="M40.8501 9.25C37.8201 15.19 36.6801 18.66 36.6801 18.66C36.6801 18.66 37.4101 7.4 23.4301 7.4C9.45008 7.4 10.1801 18.66 10.1801 18.66C10.1801 18.66 9.04009 15.19 6.01009 9.25C2.98009 3.31 0.0800781 0 0.0800781 0C2.35008 22.29 8.41007 29.23 11.3101 33.03C14.2101 36.83 23.4301 36.5 23.4301 36.5C23.4301 36.5 32.6501 36.83 35.5501 33.03C38.4501 29.23 44.5101 22.3 46.7801 0C46.7801 0 43.8801 3.31 40.8501 9.25Z"
        fill={fill}
      />
    </g>
  )
}
